import { ClipboardList } from "lucide-react";
import { useIssuesData } from "../../hooks/useIssues";
import { useAuth } from "../../context/authContext";
import GlassCard from "../ui/GlassCard";
import StatPill from "../ui/StatPill";
const TotalIssues = () => {
  const { code } = useAuth();
  const { issuesData, loading } = useIssuesData(code);

  return (
    <GlassCard accent="violet" className="text-slate-900 dark:text-white">
      <StatPill
        icon={<ClipboardList size={20} />}
        value={loading ? "..." : issuesData?.overallCount || 0}
        label="Total Issues"
        accent="#8C7CF0"
      />
    </GlassCard>
  );
};
var TotalIssues_default = TotalIssues;
export { TotalIssues_default as default };
